import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MessageService } from 'primeng/components/common/api';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-coupon-layout-setup',
  templateUrl: './coupon-layout-setup.component.html',
  styleUrls: ['./coupon-layout-setup.component.css', '../coupon-setup.scss']
})
export class CouponLayoutSetupComponent implements OnInit {
  messageInstanceId: string;
  actionId: string;
  campaignId: string;
  layoutId: number;
  workflowList: SelectItem[] = [{label: "", value: null}];
  selectedWorkflow: any;
  layout_value_mi: any;
  touchpoints: any[];
  touchpoint_default: any[]; //il touchpoint di default ha ochannel_id a null in quanto non ha un vero e proprio touchpoint collegato
  showLayoutDialog = false;
  formData: any;
  stateAction: number;
  actualStep = 'layout';
  missingLayout: boolean;
  actionTypeCode: string;
  messageInstanceData: any;
  imagePath: SafeResourceUrl = null;
  showPreview = false;
  showPreviewError: string;
  messageCode: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private campaignService: Campaign2Service,
    private messageService: MessageService,
    private router: Router,
    private translateService: TranslateService,
    private _sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.messageInstanceId = this.activatedRoute.snapshot.params['messageInstanceId'];
    this.actionId = this.activatedRoute.snapshot.params['campaignActionId'];
    this.actionTypeCode = this.activatedRoute.snapshot.paramMap.get('actionTypeCode') || null;
    //this.getWorkflowData();
    this.getMessageInstanceData();

  }

  getMessageInstanceData() {
    this.campaignService.getMessageInstanceData(this.messageInstanceId).subscribe(res => {
      this.messageInstanceData = res[0];
      this.stateAction = res[0].campaign_action_status_id;
      this.campaignId = res[0].campaign_id;
      this.selectedWorkflow = res[0].external_workflow;
      this.layout_value_mi = res[0].layout_value;
      this.getEmissionTouchpointsAndLayouts();
      this.getEmissionTouchpointAndLayoutsDefault();
      this.campaignService.getCouponParametersDefaultData(res[0].message_id).subscribe(resM => {
          this.messageCode = resM.code;
      });
    });
  }
  getWorkflowData() {
    this.campaignService.getWorkflowList().subscribe(res => {
      res.forEach(workflow => this.workflowList.push({label: workflow.description, value: workflow.param_code}));
      this.getMessageInstanceData();
    });
  }

  getEmissionTouchpointAndLayoutsDefault() {
    this.touchpoint_default = [];
    this.touchpoints = [];
    this.campaignService.getEmissionTouchpointAndLayoutsDefault(+this.messageInstanceId).subscribe(res =>
        this.touchpoint_default = res
     )
  }


  getEmissionTouchpointsAndLayouts() {
    this.touchpoint_default = [];
    this.touchpoints = [];
    this.campaignService.getEmissionTouchpointsAndLayouts(+this.actionId).subscribe(res =>
      {
        res.forEach(tp => {
          if(tp.ochannel_id != null)
            this.touchpoints.push(tp);
        })
      }
    )
  }

  openLayoutDialog(touchpoint: any) {
    this.formData = touchpoint;
    this.showLayoutDialog = true;
  }

  closeLayoutDialog() {
    this.showLayoutDialog = false;
    this.formData = null;
    this.missingLayout = false;
  }

  saveLayout(data: any) {
    if(this.formData.ochannel_id != null)
      this.campaignService.saveTouchpointLayout(+this.actionId, this.formData.layout_id, this.formData.ochannel_id, data).subscribe(() => {
        this.messageService.add({severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success')});
        this.getEmissionTouchpointsAndLayouts();
        this.getEmissionTouchpointAndLayoutsDefault();
        this.closeLayoutDialog();
      });
    else
      this.campaignService.saveTouchpointDefaultLayout(+this.messageInstanceId, this.formData.layout_id, data).subscribe(() => {
        this.messageService.add({severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success')});
        this.getEmissionTouchpointsAndLayouts();
        this.getEmissionTouchpointAndLayoutsDefault();
        this.closeLayoutDialog();
      });

  }


  checkMissingLayout() {
    this.missingLayout = false;
    this.touchpoints.forEach(tp => {
      if (!tp.form_values) {
        this.missingLayout = true;
      }
    });
    if(this.touchpoint_default.length>0 && this.touchpoint_default[0].form_values!=null)
      this.missingLayout = false;
  }

  save() {
    this.checkMissingLayout();
    if (this.missingLayout) {
      return;
    }
    /*l'external sorkflow è stato inglobato nei layout singoli di ogni ochannel, quindi lo passiamo a null*/
    this.campaignService.saveExternalWorkflowLayout(+this.messageInstanceId, null).subscribe(() => {
      this.messageService.add({severity: 'success', summary: this.translateService.instant('common.success'), detail: this.translateService.instant('common.operation_success')});
      this.router.navigate(['campaign-list-2']);
    })
    //this.router.navigate(['campaign-list-2']);
  }

  anteprimaCoupon() {
    let cassa = this.touchpoints.find(touchpoint => touchpoint.description == 'Cassa')
    let body : any;
    if(this.actionTypeCode === 'MSG'){
      let codiceModelloMsg : string;
      if(this.messageInstanceData.flg_couponing_method === 'S' && this.messageCode === 'MSG-LOY'){
        codiceModelloMsg = "KBMSG.FDLT" ;
      }else if(this.messageInstanceData.flg_couponing_method === 'D' && this.messageCode === 'MSG-ALL'){
        codiceModelloMsg = "KBMSG.TT" ;
      }else if(this.messageInstanceData.flg_couponing_method === 'D' && this.messageCode === 'MSG-NOLOY'){
        codiceModelloMsg = "KBMSG.NOFDLT" ;
      }else if(this.messageInstanceData.flg_couponing_method === 'D' && this.messageCode === 'MSG-LOY'){
        codiceModelloMsg = "KBMSG.FDLT" ;
      }
      body = {
        codiceModello: codiceModelloMsg,
        urlImmagineStampa: cassa.form_values.pos_img_url,
        dataValiditaInizio: moment(new Date(this.messageInstanceData.startEmissionDate)).format('YYYYMMDD'),
        dataValiditaFine: moment(new Date(this.messageInstanceData.endEmissionDate)).format('YYYYMMDD'),
        barcode: this.messageInstanceData.barcode,
        informativa: cassa.form_values.form[1].det_row_value,
        informativaPuntiVendita: cassa.form_values.form[0].det_row_value
      }
    }else{
      body = {
        codiceModello: "KBSV.FDLT_FDLT" ,
        urlImmagineStampa: cassa.form_values.pos_img_url,
        dataValiditaInizio: moment(new Date(this.messageInstanceData.start_fruition_date)).format('YYYYMMDD'),
        dataValiditaFine: moment(new Date(this.messageInstanceData.end_fruition_date)).format('YYYYMMDD'),
        barcode: this.messageInstanceData.barcode,
        informativa: cassa.form_values.form[1].det_row_value,
        informativaPuntiVendita: cassa.form_values.form[0].det_row_value
      }
    }

    this.campaignService.anteprimaCoupon(body).subscribe(res => {
      if(res.risposta.codiceEsito != 'OK') {
        this.imagePath = null;
        this.showPreviewError = res.risposta.descrizioneEsito;
      } else {
        this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, ' + res.oggetto)
        this.showPreviewError = null;
      }
      this.showPreview = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/coupon-layout-setup/coupon-layout-setup.component.ts